import { useContext } from "react";

import { SelectionContext } from "utils/context/selection";

export const useSelectionContext = () => useContext(SelectionContext);
